module.exports = require("@ember/object/events");